import {InfoOutlined} from '@mui/icons-material';
import DeleteForever from '@mui/icons-material/DeleteForeverOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import GroupRoundedIcon from '@mui/icons-material/GroupRounded';
import {Box, Divider, ListItemIcon, Menu, MenuItem, useTheme} from '@mui/material';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import {DEFAULT_WORKSPACE} from '../../const';
import usePayment from '../../hooks/providers/usePayment';
import useProfile from '../../hooks/providers/useProfile';
import useWorkspaces from '../../hooks/providers/useWorkspaces';
import {workspaceShape} from '../../proptypes-shapes';

const WorkspacesTabsMenu = ({workspace}) => {
  const {maxReportsDataVolumeInMegaoctets, reportsDataVolumeInMegaoctetsUsedByAllUsers} = usePayment();
  const {
    rightClickedWorkspace,
    setDeleteWorkspaceOrReportModalOpen,
    workspacesTabsMenuAchorEl: anchorEl,
    closeWorkspaceTabsMenu: handleClose,
    setIsWorkspaceUsersModalOpen,
    getDataVolumeUsedByWorkspace,
    adminExportPlatformUsage
  } = useWorkspaces();
  const {isPartnerPolicy} = useProfile();

  const theme = useTheme();
  const open = Boolean(anchorEl);

  const isDefaultWorkspaceMenu = rightClickedWorkspace?.workspace_id === DEFAULT_WORKSPACE.workspace_id;

  return (
    <Menu
      id="workspaces-tabs-menu"
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      open={open}
      onClose={handleClose}
      sx={{
        '& .MuiList-root': {
          padding: 0
        },
        '& .MuiMenuItem-root': {
          padding: 2
        }
      }}
      slotProps={{paper: {sx: {minWidth: 270}}}}
    >
      {isDefaultWorkspaceMenu ? (
        <MenuItem
          key={1}
          sx={{pt: 1.5}}
          onClick={() => {
            adminExportPlatformUsage();
          }}
        >
          <ListItemIcon>
            <DownloadIcon color="primary" />
          </ListItemIcon>
          <Grid container flexDirection="column">
            <Typography fontSize={14} variant="inherit">
              Exporter la liste
            </Typography>
          </Grid>
        </MenuItem>
      ) : (
        <Box>
          <MenuItem disabled key={1} sx={{pt: 1.5}}>
            <ListItemIcon>
              <InfoOutlined color="primary" />
            </ListItemIcon>
            <Grid container flexDirection="column">
              <Typography fontSize={14} variant="inherit">
                Utilisation de l'espace
              </Typography>
              <ul style={{listStyleType: 'disc', marginLeft: 20, fontSize: 12}}>
                <li>votre utilisation : {parseFloat(getDataVolumeUsedByWorkspace().toFixed(2))} Mo</li>
                {isPartnerPolicy ? <li>utilisation totale : {parseFloat(reportsDataVolumeInMegaoctetsUsedByAllUsers.toFixed(2))} Mo</li> : null}
                <li>souscrit : {parseFloat(maxReportsDataVolumeInMegaoctets.toFixed(2))} Mo</li>
              </ul>
            </Grid>
          </MenuItem>
          <Divider sx={{margin: '0 !important'}} />
          <MenuItem key={2} sx={{pt: 1.5}} onClick={() => setIsWorkspaceUsersModalOpen(true)}>
            <ListItemIcon>
              <GroupRoundedIcon color="primary" />
            </ListItemIcon>
            <Typography fontSize={14} variant="inherit">
              Gérer les utilisateurs
            </Typography>
          </MenuItem>
          <Divider key={3} sx={{margin: '0 !important'}} />
          <MenuItem key={4} sx={{pt: 1.5}} onClick={() => setDeleteWorkspaceOrReportModalOpen(true)}>
            <ListItemIcon>
              <DeleteForever color="error" />
            </ListItemIcon>
            <Typography fontSize={14} sx={{color: theme.palette.error.main}} variant="inherit">
              Supprimer {workspace?.workspace_name}
            </Typography>
          </MenuItem>
        </Box>
      )}
    </Menu>
  );
};

WorkspacesTabsMenu.propTypes = {
  workspace: workspaceShape.isRequired
};

export default WorkspacesTabsMenu;
